import React from "react";
import InvoicePreviewPage from "@/pages/utility/invoice-preview";

const InvoiceEPage = () => {


  return (
    <div>
      <InvoicePreviewPage />
    </div>
  );
};

export default InvoiceEPage;
